import cn from "classnames";
import { HeadingLevel } from "@ariakit/react";
import Link from "next/link";

import type {
  FeedItemVignette,
  FeedItemVignetteLink,
} from "../../../../types/content/feedItemVignette";
import type { ReactNode } from "react";

import styles from "./TeaserClusterVignette.module.scss";
import { getSlugFromTitle } from "../../../../utils/getSlugFromTitle";

const LinkHandler = ({
  children,
  link,
  entityTitle,
}: {
  link: FeedItemVignetteLink;
  entityTitle: string;
  children: ReactNode;
}) => {
  if (!link) {
    return <>{children}</>;
  }

  const isCategory = link.entityType === "category";

  const titleSlug = getSlugFromTitle(entityTitle);
  const url = isCategory
    ? `/${link.entityId}`
    : `/t/${titleSlug}/${link.entityId}` || "";

  return (
    <Link href={url} prefetch={false}>
      {children}
    </Link>
  );
};

const TeaserClusterVignette = ({
  resource,
  isNative,
  isPremium,
}: {
  resource: FeedItemVignette;
  isNative?: boolean;
  isPremium?: boolean;
}) => {
  const secondaryVignette = resource?.secondaryVignette;
  const primaryVignette = resource?.primaryVignette;
  const link = resource?.link;

  return (
    <div className={cn([styles.feedItemVignette])}>
      <LinkHandler link={link} entityTitle={primaryVignette}>
        <HeadingLevel>
          <span
            className={cn([
              styles.titleLink,
              isPremium && styles.premium,
              isNative && styles.uncoloredLink,
            ])}
          >
            {primaryVignette}
          </span>
          {secondaryVignette && (
            <>
              <span
                className={cn([styles.suffix, isNative && styles.fadedText])}
              >
                {" "}
                •{" "}
              </span>
              <span
                className={cn([
                  styles.titleLink,
                  styles.uncoloredLink,
                  isPremium && styles.premium,
                  isNative && styles.fadedText,
                ])}
              >
                {secondaryVignette}
              </span>
            </>
          )}
        </HeadingLevel>
      </LinkHandler>
    </div>
  );
};

export { TeaserClusterVignette };
